import { useTranslation } from 'react-i18next';
import { NewTypography as Typography } from '@lamimed/pantheon';
import Head from 'next/head';

import ContentBox from 'components/ContentBox';
import { FileBoxView } from 'components/FileBoxView';
import { ThemedSpinner } from 'components/ThemedSpinner';
import { ViewFileModal } from 'components/ViewFileModal';
import { useViewModal } from 'components/ViewFileModal/useViewModal';

import { PatientAreaWrapper } from '../PatientAreaWrapper/index.';
import * as S from '../PatientAreaWrapper/styles';

import { NoAppointments } from './containers/NoAppointments';
import { useUserAppointments } from './hooks/useUserAppointments';

export const patientAreaOriginKey = 'PATIENT_AREA_ORIGIN';

export function PatientAreaHomeTemplate() {
  const { t } = useTranslation();

  const { data, isInitialLoading } = useUserAppointments();

  const { viewFile, handleClose, handleViewFile, isModalViewOpen } =
    useViewModal();

  return (
    <>
      <Head>
        <title>{t('page--patient-area.title')}</title>
      </Head>

      <PatientAreaWrapper>
        <ViewFileModal
          file={viewFile}
          isOpen={isModalViewOpen}
          handleCloseModal={handleClose}
        />

        <S.Container
          positionX={isInitialLoading ? 'center' : 'end'}
          positionY={isInitialLoading ? 'center' : 'start'}
          about=""
        >
          {isInitialLoading && (
            <ThemedSpinner size="large" positionX="center" />
          )}

          {data && data.length === 0 && (
            <NoAppointments variant="nodocuments" />
          )}

          {data?.map((appointment) => (
            <ContentBox key={appointment.id} expanded loading={!appointment}>
              <Typography marginBottom="none" variant="heading_5">
                {`${appointment.start_date} - ${appointment.start_time}`}
              </Typography>

              <S.ProfessionalRow>
                <Typography marginBottom="medium" variant="body_text_3">
                  {appointment.professional}
                </Typography>

                <Typography marginBottom="medium" variant="body_text_3">
                  {appointment.activity_title}
                </Typography>
              </S.ProfessionalRow>

              <S.ContentWrapper desktopColumns="1fr 1fr">
                {appointment?.files &&
                  appointment.files.length > 0 &&
                  appointment.files.map(({ name, format, url, thumbnail }) => (
                    <FileBoxView
                      key={name}
                      thumbUrl={thumbnail}
                      fileUrl={url}
                      fileTitle={name}
                      fileExtension={format}
                      handleView={() => {
                        handleViewFile({
                          name,
                          url,
                          id: url,
                          thumbnail,
                          format,
                        });
                      }}
                    />
                  ))}
              </S.ContentWrapper>
            </ContentBox>
          ))}

          <S.GlobalArea></S.GlobalArea>
        </S.Container>
      </PatientAreaWrapper>
    </>
  );
}
